import {
  createOrGetCart,
  duplicateCartProductsRequest,
  deleteCartProductRequest,
  getCartProducts,
  addProductsRequest,
  quickAddProductsBatchRequest,
  getCartById,
  refreshCart,
  requestCurrentCartProductsDetails
} from '../../carts/actions';
import {
  setSizeQuantity,
  sortAndFilterCart,
  updateCartProductPurchasables,
  setUnitAllotmentId,
  setProductGroupAddress,
  setCurrentCartHeader,
  setCurrentCartTotals,
  setPaymentMethod,
  assignCartProductGroups,
  validateCart
} from '../../carts/actionCreators';

import { useCurrentContract } from '../../account/reducer';
import { accountIsBillable, getAllotmentsForSelectedDepartment } from '../../gamedayAccount/selectors';
import {
  getProductAvailability,
  getProductMinRules,
  getProductMaxRules,
  getSelectedDepartment
} from '../../shop/selectors';

import { getFundamentals } from '../../fundamentals/constants';
import { getProductsInfoList } from '../../productsInfo';

import { groupProductDetailSizeAvailability } from '../../shop/util/helpers';

export const ADDON_CART_VALIDATION = 'ADDON_CART_VALIDATION';

// Grab product availabilty from appropriate source
const calcProductAvailability = (action, state) =>
  // eslint-disable-next-line no-nested-ternary
  action.type === requestCurrentCartProductsDetails.event.success
    ? groupProductDetailSizeAvailability(action.payload)
    : validateCart.type || action.type === setSizeQuantity.type
    ? getProductAvailability(state)
    : {};

// Grab fundamental rules from appropriate source
const getFundamentalRules = state => getFundamentals(state).rules || {};

// Grab max rules from appropriate source
// TODO: Update this to account for specific action type once max rules are actually implemented
const calcMaxRules = (action, state) => getProductMaxRules(state) || {};

// Addon
export const cartValidationAddon = (store, action) => {
  const state = store.getState();

  switch (action.type) {
    case addProductsRequest.event.success:
    case quickAddProductsBatchRequest.event.success:
    case duplicateCartProductsRequest.event.success:
    case deleteCartProductRequest.event.success:
    case updateCartProductPurchasables.type:
    case setPaymentMethod.type:
    case setSizeQuantity.type:
    case sortAndFilterCart.type:
    case setUnitAllotmentId.type:
    case getCartById.event.success:
    case getCartProducts.event.success:
    case createOrGetCart.event.success:
    case requestCurrentCartProductsDetails.event.success:
    case setCurrentCartHeader.type:
    case setCurrentCartTotals.type:
    case setProductGroupAddress.type:
    case refreshCart.event.success:
    case assignCartProductGroups.type:
    case validateCart.type:
      return {
        ...action,
        addon: {
          ...action.addon,
          [ADDON_CART_VALIDATION]: {
            allotments: getAllotmentsForSelectedDepartment(state),
            productAvailability: calcProductAvailability(action, state),
            productMinRules: getProductMinRules(state),
            productFundamentalRules: getFundamentalRules(state),
            productMaxRules: calcMaxRules(action, state),
            selectedDepartment: getSelectedDepartment(state),
            useCurrentContract: useCurrentContract(state),
            accountIsBillable: accountIsBillable(state),
            productsInfoList: getProductsInfoList(state)
          }
        }
      };

    default:
      return action;
  }
};
